/* @flow weak */
import { apiPost } from '../lib/api'

export const SIGN_IN_START = 'SIGN_START'
export const SIGN_IN_SUCCESS = 'SIGN_IN_SUCCESS'
export const SIGN_IN_ERROR = 'SIGN_IN_ERROR'

export const SIGN_OUT = 'SIGN_OUT'

export const CLEAR_ERRORS = 'CLEAR_ERRORS'

export const signIn = ({ email, password }) => ({ getState, fetch }) => ({
  type: 'SIGN_IN',
  payload: apiPost({
    fetch,
    endpoint: 'auth/sign-in',
    getState,
    body: {
      email,
      password,
    },
  }),
})

export const clearErrors = () => ({
  type: CLEAR_ERRORS,
})

export const signOut = () => ({
  type: SIGN_OUT,
})



// WEBPACK FOOTER //
// ./src/common/auth/actions.js